import React from 'react';
import {
    getCustomers,
    getExpense,
    getIncome,
    getOpenInvoices,
    getSuppliers,
} from '../../../api';
import { buildCustomerOptions } from '../../shared/customerSelectUtils';
import { buildSupplierOptions } from '../../shared/supplierSelectUtils';
import { resolveReferenceList } from './utils';

const useAllocationReferenceData = () => {
    const [referenceLoading, setReferenceLoading] = React.useState(false);
    const [referenceData, setReferenceData] = React.useState({
        invoices: [],
        incomes: [],
        expenses: [],
        customers: [],
        suppliers: [],
    });

    const customerOptions = React.useMemo(
        () => buildCustomerOptions(referenceData.customers),
        [referenceData.customers]
    );
    const supplierOptions = React.useMemo(
        () => buildSupplierOptions(referenceData.suppliers),
        [referenceData.suppliers]
    );

    const loadReferenceData = React.useCallback(async (bookingDate) => {
        if (referenceLoading) {
            return;
        }
        setReferenceLoading(true);
        const params = {};
        if (bookingDate) {
            try {
                const date = new Date(bookingDate);
                const fromDate = new Date(date.getFullYear() - 1, date.getMonth(), date.getDate());
                const toDate = new Date(date.getFullYear() + 1, date.getMonth(), date.getDate());
                const from = fromDate.toISOString().slice(0, 10);
                const to = toDate.toISOString().slice(0, 10);
                params.dueFrom = from;
                params.dueTo = to;
                params.from = from;
                params.to = to;
            } catch (e) {
                // ignore invalid date
            }
        }
        try {
            const results = await Promise.allSettled([
                getOpenInvoices(params),
                getIncome(params),
                getExpense(params),
                getCustomers(),
                getSuppliers(),
            ]);
            const [invoiceRes, incomeRes, expenseRes, customerRes, supplierRes] = results;
            setReferenceData({
                invoices: resolveReferenceList(invoiceRes),
                incomes: resolveReferenceList(incomeRes),
                expenses: resolveReferenceList(expenseRes),
                customers: resolveReferenceList(customerRes),
                suppliers: resolveReferenceList(supplierRes),
            });
        } catch (err) {
            setReferenceData({
                invoices: [],
                incomes: [],
                expenses: [],
                customers: [],
                suppliers: [],
            });
        } finally {
            setReferenceLoading(false);
        }
    }, [referenceLoading]);

    const appendCustomer = React.useCallback((customer) => {
        if (!customer) {
            return;
        }
        setReferenceData((prev) => ({
            ...prev,
            customers: [...prev.customers, customer],
        }));
    }, []);

    const appendSupplier = React.useCallback((supplier) => {
        if (!supplier) {
            return;
        }
        setReferenceData((prev) => ({
            ...prev,
            suppliers: [...prev.suppliers, supplier],
        }));
    }, []);

    return {
        referenceData,
        referenceLoading,
        customerOptions,
        supplierOptions,
        loadReferenceData,
        setReferenceData,
        appendCustomer,
        appendSupplier,
    };
};

export default useAllocationReferenceData;
